import { type FunctionalComponent, h } from '@stencil/core';
import type { ConversationalSearchAnswer } from '../../../conversational-search-types/conversational-search-types.type';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import { getByType } from '../../../conversational-search-logic/utils/utils';

export interface IConversationalSearchNotDetailedAnswer {
  labelProvider: labelProviderInterface;
  query: string;
  data: ConversationalSearchAnswer;
}

export const ConversationalSearchNotDetailedAnswer: FunctionalComponent<
  IConversationalSearchNotDetailedAnswer
> = (props) => {
    const followUpCategories = getByType(props.data?.followups, 'conversation/followup/categories')?.categories;

    return (
      <div class="conversational-search-messages-not-detailed-answer">
        <div>
          {props.labelProvider(
            'conversational.search.not.detailed.response.intro',
            'Schneider Electric offers a wide range of products and services across various business units.',
          )}
        </div>
        <div>
          {props.labelProvider(
            'conversational.search.not.detailed.response.outro',
            'Could you please provide more details or select one of the following primary segments that match your need:',
          )}
        </div>
        {followUpCategories?.length ? (
          <section class="conversational-search-messages-not-detailed-answer__categories">
            <uiaas-search-widget-conversational-search-suggestion-button
              query={props.query}
              data={followUpCategories}
            />
          </section>
        ) : (
          ''
        )}
      </div>
    );
};
